import React, { useEffect } from "react"
import styled from "@emotion/styled"

import footerBackground from "./../images/footer-background.svg"
import ScrollTop from "../helpers/scroll-top"
import Header from "./ui/header"
import Sidebar from "./ui/sidebar"
import { useAuth } from "../hooks/auth-context"


declare global {
  interface Window {
    embeddedWebchatConfig: any
  }
}

const Container = styled.div`
  display: flex;
  min-height: 100%;
  background-image: url(${footerBackground});
  background-repeat: no-repeat;
	background-size: 100% 156.835%;
  background-position: 1% -33%;
  @media (max-width: 812px) {
    flex-direction: column;
    background-size: 132% 155.835%;
  }
  @media (max-width: 450px) {
    background-position: 1% -17%;
    background-size: 180% 172.835%;
  }
`

const Content = styled.div`
  width: 100%;
  @media (max-width: 812px) {
    padding: 0 0rem;
  }
`

type Props = {
  children: React.ReactNode
}

const Layout = ({ children }: Props) => {
  const { state } = useAuth()
  const user = state.user as User

  useEffect(() => {
    const getKycMessage = (step: string) => {
      switch (step) {
        case "kyc/personal-info":
          return "¿Todo bien por aquí? Si tienes dudas sobre qué información ingresar, puedo ayudarte. Este paso solo asegura que tu cuenta esté correctamente configurada desde el inicio."
        case "kyc/validate-documents":
          return "¿Tienes el documento a mano? Si no estás seguro de qué tipo subir o cómo hacerlo, te explico en segundos. Este paso es solo para verificar tu identidad y proteger tu cuenta"
        case "kyc/risk-profile":
          return "¿Te detuviste en alguna pregunta? Puedo aclararte qué significa cada una o por qué las hacemos. Este paso nos ayuda a ofrecerte la experiencia adecuada según tu perfil."
        case "kyc/knowledge-profile":
          return "Parece que te quedaste un momento aquí. ¿Quieres que te cuente rápidamente qué evalúa cada pregunta? No es una prueba, solo buscamos asegurarnos de que entiendas bien el producto."
        case "kyc/bad-trader-profile":
          return "Veo que estás en esta pantalla. Si quieres, puedo contarte qué significa tener este perfil y cómo podrías avanzar igual con apoyo y educación. ¿Te explico?"
        case "kyc/terms":
          return "¿Quieres que te resuma los puntos clave antes de aceptar? La idea es que tengas claridad total sobre cómo funciona tu cuenta y los riesgos del trading."
        case "kyc/deposit":
          return "¿Tienes alguna duda sobre cómo hacer tu primer depósito o los medios disponibles? Puedo guiarte paso a paso para que lo completes sin contratiempos."
        default:
          return "¿En qué puedo ayudarte?"
      }
    }

    const chatWithUsText = `¡Hola ${user.givenName}! ${getKycMessage(user.kycNextStep)}`
    window.embeddedWebchatConfig = {
      clientId: "2d871902-0e57-40d3-b353-b64ece849382",
      channelId: "6e02070f-24ca-481d-8b0b-6355f73fc9e6",
      agentName: "Customer Support",
      darkTheme: true,
      askForEmail: false,
      askForName: false,
      externalUserName: user.givenName,
      askForPhoneNumber: false,
      primaryColor: "#2BA770",
      externalUserId: user.id,
      externalUserMail: user.email,
      externalUserPhone: user.phone,
      language: "es",
      chatWithUsText: `¡Hola ${user.givenName}! ¿Necesitas ayuda?`,
      firstMessageText: chatWithUsText,
      xPosition: 20,
      yPosition: 20,
    }

    let appendedScript: HTMLScriptElement | null = null
    if (!document.querySelector('script[src="https://vambeai.com/webchat.js"]')) {
      const script = document.createElement("script")
      script.src = "https://vambeai.com/webchat.js"
      script.async = true
      document.body.appendChild(script)
      appendedScript = script
    }

    return () => {
      if (appendedScript) {
        document.body.removeChild(appendedScript)
      }
    }
   }, [user])

  return (
    <>
      <ScrollTop />
      <Header showLinks={true} />
      <Container>
        <Sidebar />
        <Content>{children}</Content>
      </Container>
    </>
  )
}

export default Layout
